import React from 'react';
import clsx from 'clsx';
import { Typography, Color, FontType } from '@americanexpress/aqx-components';
import styles from './__styles__/styles.scss?modules';

const AmazonDisclaimer = ({
  shortName,
  isAmazonModal = false,
  isLeftRail = false,
  isPDPModal = false
}) => {
  const render =
    shortName === 'amazon-business-prime' ||
    shortName === 'amazon-business' ||
    isAmazonModal;

  return (
    (render && (
      <div
        className={clsx(styles.container, {
          [styles.amazonModalContainer]: isAmazonModal,
          [styles.leftRail]: isLeftRail,
          [styles.isPDPModal]: isPDPModal
        })}
      >
        <Typography
          $family={FontType.HelveticaRegular}
          $lineHeight={20}
          $size={13}
          theme={{
            color: isAmazonModal ? Color.Gray05 : Color.Gray06
          }}
        >
          Your personal credit score may be impacted if you submit an application.
        </Typography>
      </div>
    )) ||
    null
  );
};

export default AmazonDisclaimer;
